import { useState } from "react";
import EmailPreview from "@/pages/admin/EmailPreview";
import BroadcastComposer from "@/pages/admin/BroadcastComposer";
import EmailSettings from "@/pages/admin/EmailSettings";

const SUBTABS = [
  { id: "compose", label: "Broadcast" },
  { id: "previews", label: "Previews" },
  { id: "settings", label: "Sender Settings" },
];

export default function EmailsManager() {
  const [sub, setSub] = useState("compose");
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-6" data-testid="emails-subnav">
        {SUBTABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setSub(t.id)}
            data-testid={`email-subtab-${t.id}`}
            className={`border-2 px-4 py-2 uppercase text-xs tracking-widest transition-colors ${
              sub === t.id ? "border-[#DFFF00] bg-[#DFFF00] text-[#090909]" : "border-[#F2EFEB]/40 hover:border-[#F2EFEB]"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {sub === "compose" && <BroadcastComposer />}
      {sub === "previews" && <EmailPreview />}
      {sub === "settings" && <EmailSettings />}
    </div>
  );
}
